import { conversationService } from '@/services/api'
import { groupByArrayOfObject } from '@/common/arrays'

const initialStates = {
    status: 'LOADING',
    conversationsList: {},
    pagination: {
        no_paginate: false,
        per_page: 20,
        current_page: 1,
        last_page: 1,
    },
    params: {
        page: 1
    }
}

const mutations = {
    loading(state) {
        state.status = 'LOADING'
    },
    setConversationsList(state, conversations) {
        state.status = 'SET_LIST'
        state.conversationsList = conversations
    },
    setPagination(state, pagination) {
        state.status = 'SET_PAGINATION'
        state.pagination = Object.assign({}, state.pagination, pagination)
    },
    setParams(state, params) {
        state.status = 'SET_PARAMS'
        state.params = Object.assign({}, state.params, params)
    },
    resetParams(state) {
        state.status = 'RESET_PARAMS'
        state.params = {
            page: 1
        }
    },
    updateConversation(state, conversation) {
        state.status = 'UPDATE'
        state.conversationsList[conversation._id] = Object.assign({}, state.conversationsList[conversation._id], conversation)
    },
    error(state) {
        state.status = 'ERROR'
    },
    addConversation(state, conversation) {
        state.status = 'ADD_CONVERSATION'
        state.conversationsList[conversation._id] = Object.assign({}, conversation)
    },
    addComment(state, comment) {
        state.status = 'ADD_COMMENT'
        state.conversationsList[comment.conversation_id] = Object.assign({}, state.conversationsList[comment.conversation_id], {
            comments: [
                ...state.conversationsList[comment.conversation_id].comments,
                {
                    content: comment.content,
                    created_by: comment.created_by
                }
            ]
        })
    },
    setComments(state, params) {
        state.status = 'SET_COMMENTs'
        state.conversationsList[params.id] =  Object.assign({}, state.conversationsList[params.id], {
            comments: params.comments
        })
    },
    setUnreadCount(state, params) {
        state.status = 'SET_UNREAD_COUNT'
        state.conversationsList[params.id] =  Object.assign({}, state.conversationsList[params.id], {
            unread_count: params.unread_count
        })
    }
}

const getters = {
    status: state   => state.status,
    conversations: state => state.conversationsList,
    conversationsCount: state => Object.keys(state.conversationsList).length,
    conversationById: state => id => state.conversationsList[id],
    params: state => state.params,
    pagination: state => state.pagination
}

const actions = {
    setParamsAndFetch({dispatch}, params) {
        dispatch('setParams', params)
        dispatch('fetch')
    },
    setParams({commit}, params) {
        commit('setParams', params)
    },
    resetParams({commit}) {
        commit('resetParams')
    },
    fetch({commit, state}, params) {
        params = Object.assign({}, state.params, params)

        commit('loading')

        return new Promise((resolve, reject) => {
            conversationService.fetch(params)
                .then(response => {
                    const result = response.data
                    const conversations = groupByArrayOfObject(result.data, '_id')

                    commit('setConversationsList', conversations)
                    if (params.no_paginate) {
                        commit('setPagination', {
                            no_paginate: true
                        })
                    } else {
                        commit('setPagination', {
                            per_page: result.per_page,
                            current_page: result.current_page,
                            last_page: result.last_page,
                            no_paginate: false,
                        })
                        commit('setParams', {
                            page: result.current_page,
                        })
                    }
                    resolve(result)
                })
                .catch(error => {
                    commit('error')
                    reject(error.response ? (error.response.data ? error.response.data : error.response) : error)
                })
        })
    },
    fetchContacts({}, params) {
        return new Promise((resolve, reject) => {
            conversationService.fetchContacts(params)
                .then(response => {
                    const result = response.data

                    resolve(result)
                })
                .catch(error => {
                    reject(error.response ? (error.response.data ? error.response.data : error.response) : error)
                })
        })
    },
    create({commit}, params) {
        return new Promise((resolve, reject) => {
            conversationService.create(params)
                .then(response => {
                    const result = response.data

                    commit('addConversation', result.data)
                    resolve(result)
                })
                .catch(error => {
                    commit('error')
                    reject(error.response ? (error.response.data ? error.response.data : error.response) : error)
                })
        })
    },
    addComment({commit}, params) {
        return new Promise((resolve, reject) => {
            conversationService.addComment(params)
                .then(response => {
                    commit('addComment', params)
                    resolve(response)
                })
                .catch(error => {
                    commit('error')
                    reject(error.response ? (error.response.data ? error.response.data : error.response) : error)
                })
        })
    },
    fetchMessages({commit}, conversationId) {
        return new Promise((resolve, reject) => {
            conversationService.fetchMessages(conversationId)
                .then(response => {
                    const result = response.data

                    commit('setComments', {id: conversationId, comments: result.data})
                    commit('setUnreadCount', {id: conversationId, unread_count: 0})
                    resolve(result)
                })
                .catch(error => {
                    reject(error.response ? (error.response.data ? error.response.data : error.response) : error)
                })
        })
    },
}

export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}